<template>
    <div class="notification has-text-centered rounded" :class="bulmaColorClass">
        <button @click="deleteClicked" class="delete"></button>
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'NotificationMessage',
        props: {
            bulmaColorClass: {
                type: String,
                default: 'is-primary',
            }
        },
        emits: ['deleteMsgClicked'],
        methods: {
            deleteClicked(){
                this.$emit('deleteMsgClicked')
            }
        },
    }
</script>

